import styled from "styled-components";

export const Container = styled.div`
  /* border: 1px solid #ccc; */
  border-radius: 10px;
  padding-bottom: 20px;
  background: white;
`;
export const ListProducts = styled.div`
  padding: 0px 5px;

  ${({ invisible }) => invisible && `opacity: 0;`}
`;
